import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React from "react";

const Items = ({ data, index, status }) => {
  return (
    <Stack
      direction={"row"}
      spacing={2}
      alignItems={"center"}
      whiteSpace={"nowrap"}
      className={
        index === 0 && status
          ? "animate__animated animate__bounce"
          : index === 1 && status
          ? "animate__animated animate__flipInX"
          : index === 2 && status
          ? "animate__animated animate__flipInX"
          : index === 3 && status
          ? "animate__animated animate__flipInX"
          : index === 4 && status
          ? "animate__animated animate__flipInX"
          : ""
      }
    >
      <Avatar src={data.image} alt="" variant="square" />
      <Stack flexGrow={1}>
        <Typography variant="body1">{data.title}</Typography>
        <Typography color="text.secondary" variant="caption">
          {data.text}
        </Typography>
      </Stack>
      <Stack>
        <Typography
          textAlign={"right"}
          fontWeight={700}
          variant="body2"
          color={"text.secondary"}
        >
          {data.vname}
        </Typography>
        <Typography variant="body2" color={"text.secondary"}>
          {dayjs(data.dateTime).format("D MMM YYYY HH:mm:ss")}
        </Typography>
      </Stack>
    </Stack>
  );
};

function RealEvents({ title, data = [], status, detail }) {
  return (
    <Card
      sx={{
        height: "100%",
        minHeight: 399,
        p: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardHeader
        title={title}
        titleTypographyProps={{ variant: "subtitle1" }}
        action={detail}
      />
      <CardContent
        sx={{
          flexGrow: 1,
          //display: "flex",
          //flexDirection: "column",
          //justifyContent: "space-between",
        }}
      >
        <Stack
          direction={"column"}
          spacing={2}
          >
        {data.map((ele, k) => (
          <Items key={k} data={ele} index={k} status={status} />
        ))}
        </Stack>
      </CardContent>
    </Card>
  );
}

export default RealEvents;
